import { isNil, pick } from "lodash";

import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";

import { SequoiaStatus } from "@covertree/agent-portal-graphql";
import { IconButton } from "@covertree/ui/buttons";

function StatusDetailsRow({ label, value }: { label: string; value: string }) {
  return (
    <Grid item xs={12} display="flex" justifyContent="space-between">
      <Typography>{label}</Typography>
      <Typography
        sx={{
          flexGrow: 1,
          maxWidth: "50%",
          wordBreak: "break-word",
        }}>
        {value}
      </Typography>
    </Grid>
  );
}

interface SequoiaStatusDetailsProps {
  data?: SequoiaStatus;
  onClose: () => void;
}

export function SequoiaStatusDetails({
  data,
  onClose,
}: SequoiaStatusDetailsProps) {
  if (!data) return null;

  return (
    <Drawer
      anchor="right"
      open={!!data}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            xs: "45%",
            xl: "35%",
          },
        },
      }}>
      <Box
        sx={(theme) => ({
          position: "absolute",
          top: theme.spacing(2),
          right: theme.spacing(2),
        })}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box py={2} px={2}>
        <Box mb={2} pr={5}>
          <Grid container spacing={2}>
            <Grid item>
              <Typography variant="subtitle1" gutterBottom>
                {data.status}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1" gutterBottom>
                Risk ID: {data.trackingId}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1" gutterBottom>
                Policy Locator:{" "}
                {data.policyLocator ?? "Not added to the system"}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box mb={2} px={2}>
          <Grid container spacing={2}>
            <StatusDetailsRow label="Status Reason" value={data.statusReason} />
            {data.underwritingResult &&
              Object.entries(
                pick(data.underwritingResult, ["decision", "notes"])
              ).map(([k, v]) => (
                <StatusDetailsRow
                  key={`underwriting-${k}`}
                  label={`Underwriting ${k}`}
                  value={
                    isNil(v) ? "Unknown" : Array.isArray(v) ? v.join("\n") : v
                  }
                />
              ))}
          </Grid>
        </Box>
      </Box>
    </Drawer>
  );
}
